// import components
import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';
import { LinkPlanUnitForm } from './LinkPlanUnitForm';

// import hooks
import React from 'react';

// import queries & mutations
import { useGetPlanUnitDetails } from './utils/useGetPlanUnitDetails';

// import types
import { PlanUnit, PlanUnitLink } from '../types';

// import utils
import { HierarchyPlanUnit } from './utils/treeHierarchy';

interface Props {
  onClose: () => void;
  selectedRow: PlanUnit;
  mode?: PlanUnitLink;
  hierarchy: PlanUnit[] | HierarchyPlanUnit[] | undefined;
  hasReferenceDate?: boolean;
}

export const LinkPlanUnitDetailsLoaderFeedback: React.FC<Props> = ({
  mode,
  selectedRow,
  onClose,
  hierarchy,
  hasReferenceDate
}) => {
  const { data, isFetching } = useGetPlanUnitDetails(selectedRow);

  return isFetching ? (
    <SectionSkeleton />
  ) : (
    <LinkPlanUnitForm
      onClose={onClose}
      mode={mode}
      details={data ?? []}
      selectedRow={selectedRow}
      hierarchy={hierarchy}
      hasReferenceDate={hasReferenceDate}
    />
  );
};
